export default __webpack_public_path__ + "static/media/calendar-1.5481d0e2.svg";